import DeviceDescriptionForm from './DeviceDescriptionForm';

export default DeviceDescriptionForm;